"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var emotion_1 = require("emotion");
var appStylesBase_1 = require("../../../styles/appStylesBase");
var ErrorMessage = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, props = tslib_1.__rest(_a, ["className"]);
    return (react_1.default.createElement("p", tslib_1.__assign({ className: "ErrorMessage ".concat((0, emotion_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n        font-size: ", ";\n        font-style: italic;\n        color: ", ";\n        transition: height 0.1s ease-in-out;\n      "], ["\n        font-size: ", ";\n        font-style: italic;\n        color: ", ";\n        transition: height 0.1s ease-in-out;\n      "])), (0, appStylesBase_1.appStylesBase)().fontSizes.small, (0, appStylesBase_1.appStylesBase)().backgroundColor.danger.medium), " ").concat(className) }, props)));
};
exports.ErrorMessage = ErrorMessage;
var templateObject_1;
